module.exports = __webpack_public_path__ + "static/Blob4-57c5603bddeb090ff935a03efa1c054d.png";